<template>
  <ModalCard
    :is-scrollable="false"
    :data-e2e="BillingCypressAttribute.views.PROTECTION_MANDATE_MODAL"
  >
    <template #header>
      <div class="is-size-1">{{ $t('billing.confirm-your-purchase') }}</div>
    </template>
    <template #body>
      <CheckoutSessionAddonCard
        v-model="form"
        class="mb-3"
        :description="ProtectionMandateProductDescription"
        :show-legal-disclaimer="true"
        :has-controls="false"
      />
    </template>
    <template #footer>
      <div class="is-flex is-justify-content-space-between is-full-width">
        <ButtonView type="is-primary is-outlined" @click="back">{{ $t('core.back') }}</ButtonView>
        <ButtonView type="is-primary" @click="preSubmit">
          {{ $t('billing.continue-to-payment') }}
        </ButtonView>
      </div>
    </template>
  </ModalCard>
</template>

<script>
import ModalCard from '@/modules/core/ui/components/ModalCard.vue';
import { CheckoutSessionCart } from '@/modules/billing/models/CheckoutSessionCart';
import { ProductKey } from '@/modules/estate/enums/ProductKey';
import CheckoutSessionAddonCard from '@/modules/billing/components/checkout/CheckoutSessionAddonCard.vue';
import { FormFlowCompletionMixin } from '@/modules/core/form/mixins/FormFlowCompletionMixin';
import ModalService from '@/modules/core/ui/services/ModalService';
import { BillingCypressAttribute } from '@/modules/billing/constants/BillingCypressAttribute';
import ProtectionMandateProductDescription from '@/modules/billing/constants/ProtectionMandateProductDescription';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ProtectionMandateCheckoutSessionFlow',
  mixins: [FormFlowCompletionMixin],
  components: { ButtonView, CheckoutSessionAddonCard, ModalCard },
  props: {
    value: {
      type: CheckoutSessionCart
    }
  },
  static: {
    ProductKey,
    BillingCypressAttribute,
    ProtectionMandateProductDescription
  },
  methods: {
    preSubmit() {
      this.form.productKeys = [ProductKey.INDIVIDUAL_PROTECTION_MANDATE];

      this.form.successUrl = window.location.href;
      this.submit();
    },
    back() {
      ModalService.close();
    }
  }
};
</script>
